module.exports = __webpack_public_path__ + "img/nedir-06.4096bbdc.svg";